import Link from 'next/link';
import React, { useRef, useState, useEffect } from 'react';
import { truncate } from '../../../../../utils/stringutils';
import { formatUrl } from '../../../../../utils/urlUtil';
import { Description, InfoPopoutContainer, MoreInfoLink, TruncatedLinkText } from './InfoPopout.styles';

type Props = {
    url: string;
    index: number;
    description: string;
};

const InfoPopout = ({ url, index, description }: Props): JSX.Element => {
    const ref = useRef(null);
    const [height, setHeight] = useState<number>(0);

    useEffect(() => {
        setHeight(ref.current.scrollHeight);
    }, []);

    const TRUNCATION_LENGTH = 200;

    const shortenedDescription = description ? truncate(description, TRUNCATION_LENGTH) : null;

    return (
        <InfoPopoutContainer ref={ref} height={height}>
            {shortenedDescription && (
                <Description key={`transition-${index}`}>{shortenedDescription}</Description>
            )}
            <Link href={url} passHref>
                <MoreInfoLink href={formatUrl(url, { info: 'visa' })}>
                    <TruncatedLinkText>Mer </TruncatedLinkText>om programmet
                </MoreInfoLink>
            </Link>
        </InfoPopoutContainer>
    );
};

export default InfoPopout;
